export default "__VITE_ASSET__k4KR1Nl7__"